(function(){
'use strict';

angular.module('classy.frs', ['classy', 'angularSpinner', 'ui.router', 'ui.router.metatags']).constant('FRS', {});
})();